<template>
	<!-- 
		------- DO NOT USE --------
		DEV TO DO: Per offline discussion, this file should be removed in favor of using the button.vue component instead.
		Please remove and replace any existing use of the anchor component accordingly -->
	<a
		:id="uid"
		:class="[isButton ? 'btn' : '', className]"
		:title="title"
		:disabled="disabled"
		:variant="variant"
		@click="handleClick"
	>
		<i
			v-if="iconBeforeLabel === true"
			class="icon"
			:class="iconClassName"
		></i>
		<slot>
			<span v-if="labelText" class="btn__label">{{ labelText }}</span>
		</slot>
		<i
			v-if="iconBeforeLabel === false"
			class="icon"
			:class="iconClassName"
		></i>
	</a>
</template>

<script>
export default {
	name: 'Anchor',
	props: {
		className: {
			type: String,
			default: ''
		},
		title: {
			type: String,
			default: ''
		},
		iconClassName: {
			type: String,
			default: ''
		},
		iconBeforeLabel: {
			type: Boolean,
			default: null
		},
		labelText: {
			type: String,
			default: null
		},
		isButton: {
			type: Boolean,
			default: false
		}
	},
	methods: {
		handleClick(e) {
			this.$emit('click', e);
		}
	}
};
</script>
<style lang="scss"></style>
